import React from 'react';

import withState from '../../../../../../utils/withState';
import {paramStore} from "../../../../../../stores";

import Details from "./components/Details";
import List from "./components/List";

const paramsId$ = paramStore('id');

export default withState(() => {
  return (state) => {
    console.log(paramsId$.getValue());

    return state.id
      ? (
        <Details id={state.id} />
      ) : (
        <List />
      )
  };
}, {
  id: paramsId$
})
